import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchConToken } from 'helpers/fetch';
import { useUIUtils } from 'hooks/useUIUtils';
import { currency } from 'resources/utilities';
import { avisarError, nombreEstatus, nombreTipoDocto, Tarjeta } from '../comun';

const View = ({ match }) => {
    const { id } = match.params;
    const { changeGlobalTitle } = useUIUtils();
    const [documento, setDocumento] = useState(null);
    const lista = match.url.replace(/\/ver\/.*$/, '');

    useEffect(() => {
        changeGlobalTitle('Documento', `Documento ${id}`);
        fetchConToken(`pv/PvDocumentos?id=${id}`).then((response) => {
            if (!avisarError(response)) setDocumento(response);
        });
    }, [changeGlobalTitle, id]);

    if (!documento) return null;
    //const ordenPendiente = documento.tipo_Docto === 'O' && documento.estatus === 'P';

    return (
        <div className='container-fluid'>
            <div className='mb-3'>
                <Link to={lista} className='btn btn-outline-warning'>Regresar</Link>

            </div>
            <Tarjeta titulo={`${nombreTipoDocto(documento.tipo_Docto)} ${documento.folio || ''}`}>
                <div className='row'>
                    <div className='col-md-3'>Estatus: {nombreEstatus(documento.estatus)}</div>
                    <div className='col-md-3'>Fecha: {String(documento.fecha || '').slice(0, 10)} {documento.hora}</div>
                    <div className='col-md-3'>Cliente: {documento.clave_Cliente || documento.cliente_Id}</div>
                    <div className='col-md-3'>Total: {currency(documento.total_Importe)}</div>
                    <div className='col-md-3'>Neto: {currency(documento.importe_Neto)}</div>
                    <div className='col-md-3'>Impuestos: {currency(documento.total_Impuestos)}</div>
                    <div className='col-md-3'>Descuento: {currency(documento.total_Descuento)}</div>
                    <div className='col-md-3'>Descripcion: {documento.descripcion}</div>
                </div>
            </Tarjeta>
            {documento.detalle?.length > 0 && (
                <Tarjeta titulo='Partidas'>
                    <table className='table table-sm'>
                        <thead><tr><th>Articulo</th><th>Unidades</th><th>Devueltas</th><th>Precio</th><th>Importe</th></tr></thead>
                        <tbody>
                            {documento.detalle.map((item) => (
                                <tr key={item.id}>
                                    <td>{item.clave_Articulo || item.articulo_Id}</td>
                                    <td>{item.unidades}</td>
                                    <td>{item.unidades_Devueltas}</td>
                                    <td>{currency(item.precio_Unitario)}</td>
                                    <td>{currency(item.precio_Total_Neto)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Tarjeta>
            )}
            {documento.cobros?.length > 0 && (
                <Tarjeta titulo='Cobros'>
                    <table className='table table-sm'>
                        <thead><tr><th>Forma</th><th>Importe</th><th>Moneda</th></tr></thead>
                        <tbody>
                            {documento.cobros.map((item) => (
                                <tr key={item.id}><td>{item.forma_Cobro_Id}</td><td>{currency(item.importe)}</td><td>{item.moneda}</td></tr>
                            ))}
                        </tbody>
                    </table>
                </Tarjeta>
            )}
            {documento.aplicaciones?.length > 0 && (
                <Tarjeta titulo='Aplicaciones'>
                    <table className='table table-sm'>
                        <thead><tr><th>Cargo</th><th>Importe</th></tr></thead>
                        <tbody>
                            {documento.aplicaciones.map((item) => (
                                <tr key={item.documento_CC_Id}><td>{item.folio_Cargo || item.documento_CC_Id}</td><td>{currency(item.importe)}</td></tr>
                            ))}
                        </tbody>
                    </table>
                </Tarjeta>
            )}
        </div>
    );
};

export { View };
